import { __assign } from "tslib";
import { getControlTreatmentsWithConfig, ERROR_UT_NO_USECONTEXT } from './constants';
import { checkHooks } from './utils';
import { INITIAL_CONTEXT } from './SplitContext';
import { useSplitClient } from './useSplitClient';
/**
 * 'useSplitTreatments' is a hook that returns an SplitContext object extended with a `treatments` property containing an object of feature flag evaluations (i.e., treatments).
 * It uses the 'useSplitClient' hook to access the client from the Split context, and invokes the 'getTreatmentsWithConfig' method.
 *
 * @return A Split Context object extended with a TreatmentsWithConfig instance, that might contain control treatments if the client is not available or ready, or if split names do not exist.
 * @see {@link https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK#get-treatments-with-configurations}
 */
export function useSplitTreatments(splitNames, attributes, key) {
    var context = checkHooks(ERROR_UT_NO_USECONTEXT) ? useSplitClient(key) : INITIAL_CONTEXT;
    var client = context.client;
    var treatments = client && client.__getStatus().isOperational ?
        client.getTreatmentsWithConfig(splitNames, attributes) :
        getControlTreatmentsWithConfig(splitNames);
    return __assign(__assign({}, context), { treatments: treatments });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-react/es/useSplitTreatments.js
// module id = 3955
// module chunks = 25